import api from "../api/api";
const recent = new Map();
export async function trackStoreVisit(storeName, path) {
  const key = `${storeName}:${path}`;
  if (Date.now() - (recent.get(key) || 0) < 10000) return;
  recent.set(key, Date.now());
  try {
    let visitorId = localStorage.getItem("visitorId");
    if (!visitorId) {
      visitorId = crypto.randomUUID();
      localStorage.setItem("visitorId", visitorId);
    }
    let referrer = "";
    try {
      referrer = document.referrer ? new URL(document.referrer).origin : "";
    } catch (_) {}
    await api.post("/home/store/visit", {
      storeName,
      visitorId,
      path: path.split(/[?#]/)[0],
      referrer,
    });
  } catch (_) {
    recent.delete(key);
  }
}
